module.exports = __webpack_public_path__ + "img/KSC08750.1e40473b.jpg";